module.exports = __webpack_public_path__ + "img/amethyst-coral.ceb38353.png";